import { create } from 'zustand';
import { Notification } from '@prisma/client';

type UpcomingMeeting = {
  id: string;
  startTime: string;
  endTime: string;
  wherebyRoomUrl: string | null;
  mentorUserId: string;
  menteeUserId: string;
  mentorName?: string;
  menteeName?: string;
} | null;

interface NotificationStore {
  notifications: Notification[];
  unreadCount: number;
  upcomingMeeting: UpcomingMeeting;
  fetchNotifications: () => Promise<void>;
  markAllAsRead: () => Promise<void>;
  markOneAsRead: (notificationId: string) => Promise<void>;
}

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  unreadCount: 0,
  upcomingMeeting: null,
  fetchNotifications: async () => {
    try {
      const response = await fetch('/api/notifications');
      const { unreadCount, notifications, upcomingMeeting } = await response.json();
      set({ 
        notifications: notifications, 
        unreadCount: unreadCount,
        upcomingMeeting: upcomingMeeting || null,
      });
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    }
  },
  markAllAsRead: async () => {
    const { notifications } = get();
    set({
      notifications: notifications.map(n => ({ ...n, readAt: new Date() })),
      unreadCount: 0,
    });
    try {
      await fetch('/api/notifications/mark-as-read', { method: 'POST' });
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
      // Revert state if API call fails
      get().fetchNotifications();
    }
  },
  markOneAsRead: async (notificationId: string) => {
    const { notifications } = get();
    set({
        notifications: notifications.map(n => 
            n.id === notificationId ? { ...n, readAt: new Date() } : n
        ),
        unreadCount: get().unreadCount - 1,
    });
    // No API call here as it's handled by clicking the notification link
  },
}));
